import React, { useEffect, useState, memo } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  CardHeader,
  CardContent,
  Box,
  Card,
  Divider,
  useTheme,
  MenuItem,
  IconButton,
  Collapse,
  CardActions,
} from "@material-ui/core";
import Page from "components/Page";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { ModalGeneral } from "components";
import { useForm } from "react-hook-form";
import getErrorMessage from "utils/getErrorMessage";
import GraficaTareas from "./Components/GraficaTareas";
import GraficaSeguimientos from "./Components/GraficaSeguimientos";
import CardInfo from "./Components/FormularioSolicitud";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { useLocation } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DetalleTarea from "./Components/DetalleTarea";
import DetalleSeguimiento from "./Components/DetalleSeguimiento";
import { useNavigate } from "react-router-dom";
import HeaderSelectsGrafica from "general/HeaderSelectsGrafica";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  timeline: {
    minHeight: "200px",
  },
  header: {
    position: "absolute",
    bottom: "8px",
    left: "16px",
  },
}));

const Panelsol = ({permisos} ) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const navigate = useNavigate();
  const [ctl, setCtl] = useState({
    grupos: [],
    indicadoresTarea: [],
    info: [],
    infosol: [],
    personas: [],
    getSol: [],
  });
  const [modalCancelar, setModalCancelar] = useState({ open: false });
  const { register, handleSubmit, errors, watch, setValue, reset } = useForm();
  const { state } = useLocation();
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });

  const cerrarAdvertencia = () =>
    setMAdvertencia({ ...mAdvertencia, open: false });
  const cerrarModalCancelar = () =>
    setModalCancelar({ ...modalCancelar, open: false });
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
      cerrarAdvertencia();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  };

  const clickRegresar = () => {
    // console.log(state.idsolicitud );
    navigate("/Panel", { state: { id: state.idsolicitud } });
  };
  const clickRegresarS = () => {
    // console.log(state.idsolicitud );
    navigate("/");
  };


  const servicios = {
    get: () => {
      serviciosSolicitudes.IndicadoresTarea(
        (data) => {
          setCtl({
            ...ctl,
            indicadoresTarea: data.indicadoresTarea,
            infosol: data.infoSol,
            seguimientos: data.seguimientos,
            incidencias: data.incidencias,
            personas: data.personas,
            getSol: data.selectSol,
            infosolMalcance: data.infosolMalcance
            // indicadoresTareaP: data.indicadoresTareaP,
          });
        },
        setCargando,
        { idsolicitud: state.idsolicitud }
      );
    },
  };
  // getSol: () => {
  //   serviciosSolicitudes.solicitudesSelects(
  //     (data) => {
  //       setCtl({
  //         ...ctl,
  //         getSol: data.selectSol,
  //       });
  //     },
  //     setCargando,
  //     {}
  //   );
  // },
  useEffect(() => {
    servicios.get(setData, setCargando);
  }, []);

  const opcionesgrupo = [];

  const [datosF, setDato] = React.useState({ grupo: "", year: "" });
  const [grupo, setGrupoo] = React.useState("");
  let minOffset = 0,
    maxOffset = 4;
  let thisYear = new Date().getFullYear();
  let allYears = [];
  for (let x = 0; x <= maxOffset; x++) {
    allYears.push(thisYear - x);
  }

  const yearList = allYears.map((x) => {
    return <MenuItem value={x}>{x}</MenuItem>;
  });

  const theme = useTheme();
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index) {
    return {
      id: `wrapped-tab-${index}`,
      "aria-controls": `wrapped-tabpanel-${index}`,
    };
  }
  const datosTareas = "Adamss";
  const fecha1 = new Date(2021, 11, 21);
  const fecha2 = new Date(2021, 12, 1);
  const datos = [
    ["Adams", new Date(2021, 11, 21), new Date(2021, 12, 1)],
    ["fdsf", new Date(2021, 11, 21), new Date(2021, 12, 1)],
    ["Adamdsfs", new Date(2021, 11, 21), new Date(2021, 12, 1)],
  ];
  const [value, setValues] = React.useState("one");

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const clickEditar = (item) => {
    var idx = ctl.indicadoresTarea[item];
    setMAdvertencia({
      open: true,
      id: item,
      info: idx,
      Formulario: DetalleTarea,
      titulo: "DETALLE TAREA",
      // guardar: updateTarea,
      // tipo: "updateTarea",
      // t: "update",
    });
  };
  const clickDetalleSeguimiento = (item) => {
    var idx = ctl.seguimientos[item];
    // console.log(idx.tipo);
    setMAdvertencia({
      open: true,
      id: item,
      info: idx,
      Formulario: DetalleSeguimiento,
      titulo:
        "DETALLE " + (idx.tipo == "Incidencia" ? "INCIDENCIA" : "SEGUIMIENTO"),
      // guardar: updateTarea,
      // tipo: "updateTarea",
      // t: "update",
    });
  };
  // console.log(ctl.infosol.titulo);
  // console.log(ctl.infosol.titulo);

  return (
    <Page
      className={classes.root}
      title="Panel de indicadores"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        { permisos?.selectGrafica ?
          <HeaderSelectsGrafica
          id={state.idsolicitud}
          register={register}
          getSol={ctl.getSol}
          badera={1}
          handleSubmit={handleSubmit}
          setCtl={setCtl}
          ctl={ctl}
          setCargando={setCargando}
          setValue={setValue}
          watch={watch}
          errors={getErrorMessage(errors)}
          /> : null
        }
       
        {/* <Header title="PANEL" subtitle="Indicadores" /> */}

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                style={{ textAlign: "center" }}
                // title="Solicitud"
                title={
                  "#" + ctl.infosol.idsolicitud + " - " + ctl.infosol.titulo
                }
                avatar={
                  <React.Fragment>
                    {ctl.infosol.idestatus != 5 && <Button variant="contained" color="primary" onClick={clickRegresar}>
                      GESTIONAR SOLICITUD
                    </Button>}
                    &nbsp;
                    <Button variant="contained" onClick={clickRegresarS}>
                      SOLICITUDES
                    </Button>
                  </React.Fragment>
                }
                action={
                  <React.Fragment>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleExpandClick}
                    >
                      {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                    {/* <IconButton
                      className={classes.header}
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleExpandClick}
                    >
                      {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton> */}
                  </React.Fragment>
                }
              />
              <Divider />

              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <CardInfo
                    register={register}
                    ctl={ctl}
                    setValue={setValue}
                    watch={watch}
                    errors={getErrorMessage(errors)}
                    // defaultItem={modal.item || {}}
                  />
                </CardContent>
              </Collapse>

              <CardActions></CardActions>
              {/* <Divider /> */}
            </Card>
            <div className={classes.root}>
              <AppBar position="static">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="wrapped label tabs example"
                >
                  <Tab
                    value="one"
                    label="Tareas"
                    wrapped
                    {...a11yProps("one")}
                  />
                  <Tab
                    value="two"
                    label="Seguimiento/incidencia"
                    {...a11yProps("two")}
                  />
                  {/* <Tab
                    value="three"
                    label="Incidencia"
                    {...a11yProps("three")}
                  /> */}
                </Tabs>
              </AppBar>

              <TabPanel value={value} index="one">
                {ctl.indicadoresTarea && ctl.indicadoresTarea.length > 0 ? (
                  <GraficaTareas
                    register={register}
                    ctl={ctl.indicadoresTarea}
                    ctll={ctl.info}
                    clickEditar={clickEditar}
                    // ctlp={ctl.indicadoresTareaP}
                    setValue={setValue}
                  />
                ) : (
                  <Card>
                    <CardHeader title="No hay datos registrados." />
                  </Card>
                )}
              </TabPanel>
              <TabPanel value={value} index="two">
                {ctl.seguimientos && ctl.seguimientos.length > 0 ? (
                  <GraficaSeguimientos
                    register={register}
                    // ctl={ctl.indicadoresTarea}
                    ctl={ctl.seguimientos}
                    clickEditar={clickDetalleSeguimiento}
                    // ctlp={ctl.indicadoresTareaP}
                    setValue={setValue}
                  />
                ) : (
                  <Card>
                    <CardHeader title="No hay datos registrados." />
                  </Card>
                )}
              </TabPanel>
              {/* <Button variant="text" onClick={clickRegresar}>
                REGRESAR
              </Button> */}
              {/* <TabPanel value={value} index="three">
                <GraficaIncidencias
                  register={register}
                  // ctl={ctl.indicadoresTarea}
                  ctl={ctl.incidencias}
                  clickEditar={clickEditar}
                  // ctlp={ctl.indicadoresTareaP}
                  setValue={setValue}
                />
              </TabPanel> */}
            </div>
          </Grid>
        </Grid>
      </Container>
      {/* <ModalFormulario
        open={mAdvertencia.open}
        titulo={mAdvertencia.titulo}
        // OnCancelar={}
        OnCancelar={cerrarAdvertencia}
      >
        {mAdvertencia.Formulario && (
          <mAdvertencia.Formulario
            register={register}
            ctl={ctl}
            info={mAdvertencia.info}
            setValue={setValue}
          />
        )}
      </ModalFormulario> */}
      <ModalGeneral
       open={mAdvertencia.open}
       titulo={mAdvertencia.titulo}
       acciones={<React.Fragment>
        <Button color="default" className="btnError" onClick={cerrarAdvertencia}>Cerrar</Button>
        {/* <Button color="primary" onClick={mAdvertencia.aceptar}>ACEPTAR</Button> */}
      </React.Fragment>}
       // OnCancelar={}
       OnCancelar={cerrarAdvertencia}>
          {mAdvertencia.Formulario && (
          <mAdvertencia.Formulario
            register={register}
            ctl={ctl}
            info={mAdvertencia.info}
           
            setValue={setValue}
          />
          
        )}

      </ModalGeneral>
    </Page>
  );
};

export default memo(Panelsol);
